{
  "models": [
    {
      "name": "manifold_master",
      "description": "large plaque découpée avec creux à l'intérieur",
      "defaultVisible": true,
      "position": { "x": 0, "y": 0, "z": 0 },
      "rotation": { "x": 0, "y": 0, "z": 0 },
      "scale": { "x": 0.2, "y": 0.2, "z": 0.2 },
      "views": [{
          "full": [{
              "name": "manifold_full",
              "key": "modelFull",
              "url": "./static/3d/manifold_full.glb"}],
          "sliced": [{
              "name": "manifold_sliced",
              "key": "modelSliced",
              "url": "./static/3d/manifold_sliced.glb"}]
      }
      ],
      "interests": [{
            "position": {
                "x": -0.3,
                "y": -0.3,
                "z": 0.3
            },
            "label": "Largeur de 30mm"
        },
        {
            "position": {
                "x": 0.2,
                "y": 0.2,
                "z": -0.2
            },
            "label": "Largeur de 10mm"
        }],
      "material": {
        "color": "0xFFFBF2",
        "roughness": 0.6,
        "metalness": 0.5,
        "envMapIntensity": 1.5
      },
      "animation": {
        "rotationSpeed": { "x": 0, "y": 0.0001, "z": 0 }
      }
    }
  ]
}
